import React from 'react';
import PropTypes from 'prop-types';
import SearchIcon from '@material-ui/icons/Search';
import SearchInput from 'components/SearchInput';
import withStyles from '@material-ui/core/styles/withStyles';
import Style from 'assets/jss/material-dashboard-pro-react/views/fyndaStyle.jsx';

const SearchBox = ({ classes, onChange }) => (
  <div
    style={{
      backgroundColor: '#9EA0EE',
      borderRadius: '15px',
      boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.25)',
      width: '100%',
      padding: '0px 10px 0px 15px',
    }}
  >
    <SearchIcon
      style={{
        color: '#FFFFFF',
        margin: '-30px 10px -8px 0px',
      }}
      className={classes.searchBody}
    />
    <SearchInput
      formControlProps={{
        style: {
          width: '80%',
          margin: '-20px 0px 10px 0px',
          color: '#FFFFFF',
        },
      }}
      id='query'
      inputProps={{
        onChange: (e) => onChange(e.target.value),
        placeholder: 'Search...',
        inputProps: {
          'aria-label': 'Search',
        },
      }}
    />
  </div>
);

SearchBox.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(Style)(SearchBox);
